
export class PrintToPDF {
    constructor() {

    }

    triggerPrint(targetElement: JQuery<HTMLElement>, filename: string, prependHtml: string = ""): void {
        // Get HTML for PDF view
        let html = this.createPrintView(targetElement, filename, prependHtml);

        // Create iFrame element to store PDF
        let frame = document.createElement('iframe');

        // Removes Frame when print is complete
        let cleanup = () => {
            try {
                document.body.removeChild(frame);
            }
            catch {
                console.log("Error removing Frame from body");
            }
        };

        // when frame is loaded in browser
        frame.onload = () => {

            let frameWindow = frame.contentWindow;
            let doc = frame.contentDocument || frameWindow?.document;

            if (!frameWindow || !doc) {
                cleanup();
                return;
            }

            let frameTitle = this.createPdfFileName(filename);
            try {
                doc.title = frameTitle;
            }
            catch {

            };

            let oldTitle = document.title;
            document.title = frameTitle;

            let restoreTitle = () => {
                document.title = oldTitle;
                cleanup();
            }

            if ('srcdoc' in frame) {
                (frame as any).srcdoc = html;
            }
            else {
                let frameWindow = frame.contentWindow;
                let doc = frame.contentDocument || frameWindow?.document;
                if (doc) {
                    doc.open();
                    doc.write(html);
                    doc.close();
                }
            }

            setTimeout(() => {
                try {
                    frameWindow.focus();
                    frameWindow.print();

                    if ('onafterprint' in frameWindow) {
                        frameWindow.onafterprint = restoreTitle;
                    }
                    else {
                        setTimeout(restoreTitle, 1500);
                    }
                }
                catch (e) {
                    restoreTitle();
                }
            }, 50);
        }

        // Add styling so frame is not shown in browser
        frame.style.position = 'fixed';
        frame.style.right = '0';
        frame.style.bottom = '0';
        frame.style.width = '0';
        frame.style.height = '0';
        frame.style.border = '0';
        document.body.appendChild(frame);
    }

    private createPrintView(targetElement: JQuery<HTMLElement>, filename: string, prependHtml: string = ""): string {
        let currentView = targetElement;
        let viewClone = currentView.clone(false, false);

        let headAssets = this.collectHeadAssetsHtml();
        let fileName = this.createPdfFileName(filename);

        if (prependHtml) {
            viewClone.prepend(prependHtml);
        }

        let html = `
            <!doctype html>
            <html>
                <head>
                    <meta charset="utf-8">
                    <title>${fileName}</title> 
                    <base href="${document.baseURI}">
                    ${headAssets}
                    <style>body{background:#fff;padding:36px}</style>
                </head>
                <body>${viewClone.prop('outerHTML')}</body>
            </html>
        `;

        return html;
    };

    private createPdfFileName(filename: string): string {
        let displayName = `download`;
        if (filename) {
            displayName = filename;
        }
        let formattedName = displayName.replace(/[\\/:*?"<>|]+/g, '')      // strip illegal filename chars
            .replace(/\s+/g, '_')
            .trim()
            .slice(0, 180);
        return formattedName;
    }

    /** Copy page CSS into the print */
    private collectHeadAssetsHtml(): string {
        const pick = (sel: string) => Array.from(document.querySelectorAll(sel));

        // Everything already loaded on the main page
        const pageLinks = ([
            ...pick('link[rel~="stylesheet"]'),
            ...pick('link[rel="preload"][as="style"]')
        ] as HTMLLinkElement[]).map(l => l.href);

        // Unique + ordered
        const hrefs = Array.from(new Set([...pageLinks]));

        // Any inline <style> blocks on the page
        const inlineStyles = pick('style') as HTMLStyleElement[];


        return [
            ...hrefs.map(href => `<link rel="stylesheet" href="${href}">`),
            ...inlineStyles.map(s => s.outerHTML)

        ].join('\n');
    }
}